// extracted by mini-css-extract-plugin
export var formContainer = "_h6-0";
export var message = "_h6-1";